export default __webpack_public_path__ + "static/media/impact.f28cb7cb.png";